import _ from "lodash";
import { Children, useEffect, useRef, useState } from "react";
import { Button, Checkbox, Dropdown, DropdownItemProps, Form, FormProps, Icon, Input, Label, Modal, Segment, Select, Table, TextArea, TextAreaProps } from "semantic-ui-react";
import { dialogControl } from "../controls/dialog-control";
import { useCurrentUser } from "../hooks/auth-hook";
import { ModalControlData, useModalControl } from "../hooks/commonHooks";
import { useFormConnect, useFormData } from "../hooks/formHooks";
import { restRequest } from "../http";
import { PageData } from "../models/common_model";
import { DATA_TYPE_ARRAY, DATA_TYPE_OTHER, DATA_TYPE_SCALAR, DATA_TYPE_VECTOR, DropdownOption } from "../models/testing_model";
import { FieldConfigs, generateFilterFieldsConfig, TestingDataFilterData, TestingDataFilter, TestingResultOptionsData } from "../models/testing_setting_model";
import { compareMeasurementName, fieldError, formatDateTime } from "../utils";
import { Page } from "./commons/Page";
import { TextEditor } from "./commons/TextEditor";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import $ from 'jquery';
import { nextTick } from "process";
import { notificationControl } from "../controls/notification-control";
import { compareByDepth } from "framer-motion/types/render/utils/compare-by-depth";
import { TestingDataDropdown } from "./commons/TestingDataMenu";


export function TestingDataFilterComponent(props: {}) {
    const currentUser = useCurrentUser();

    const [searchData, setSearchField] = useFormData<any>({});
    const [page, setSearchData, pageLoading] = useFormConnect<any, PageData<TestingDataFilterData>>({}, 'testing_settings/filters/search');

    const editModalControl = useModalControl<number>();

    return <>
        <Segment.Group>
            <Segment attached="top">
                <Form onSubmit={e => {
                    e.preventDefault();
                    setSearchData(searchData);
                }} loading={pageLoading}>
                    <Form.Group>
                        <Form.Field inline>
                            <Input placeholder="Name" name="name" value={searchData['name'] || ''} onChange={setSearchField} />
                        </Form.Field>
                        <Form.Field inline>
                            <Input placeholder="Product" name="product" value={searchData['product'] || ''} onChange={setSearchField} />
                        </Form.Field>
                        <Form.Field inline>
                            <Input placeholder="Testing Station" name="testing_station" value={searchData['testing_station'] || ''} onChange={setSearchField} />
                        </Form.Field>
                        <Form.Field inline>
                            <Input placeholder="Order" name="order" value={searchData['order'] || ''} onChange={setSearchField} />
                        </Form.Field>

                        <div><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <th>Name</th>
                            <th>Product</th>
                            <th>Testing Station</th>
                            <th>Order</th>
                            <th>Created By</th>
                            <th>Created At</th>
                            <th>{currentUser.permissions.testing.setting.filter.create && <Button color="blue" icon="add" content="Custom Filters" size="mini" onClick={e => {
                                editModalControl.data = undefined;
                                editModalControl.setOpen(true);
                            }} />}</th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {page?.items.map(obj => {
                            return <tr key={obj.id}>
                                <td title={obj.description}>{obj.name}</td>
                                <td>{obj.product}</td>
                                <td>{obj.testing_station}</td>
                                <td>{obj.order}</td>
                                <td>{obj.created_by_name}</td>
                                <td>{formatDateTime(obj.created_at)}</td>
                                <td>
                                    {currentUser.permissions.testing.setting.filter.update && <Button onClick={e => {
                                        editModalControl.data = obj.id;
                                        editModalControl.setOpen(true);
                                    }} color="blue" icon="edit" size="mini" />}

                                    {currentUser.permissions.testing.setting.filter.delete && <Button onClick={e => {
                                        dialogControl.deletionConfirm(obj.name, agree => {
                                            if (agree) {
                                                return restRequest('testing_settings/filters/' + obj.id, null, 'delete').then(() => setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 })));
                                            }
                                            return Promise.resolve();
                                        })
                                    }} color="red" icon="delete" size="mini"></Button>}
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={page} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>

        <Editor modalControl={editModalControl} onFinish={result => {
            setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
            editModalControl.setOpen(false)
            setSearchData((ds: any) => ({ ...ds, refresh_number: (ds.refresh_number || 0) + 1 }))
        }}></Editor>
    </>
}

function Editor(props: { allRoles?: { id: number, name: string }[], modalControl: ModalControlData<number | undefined>, onFinish: (data: TestingDataFilterData) => void }) {
    const { modalControl: modelControl, onFinish } = props;
    const isCreate = !modelControl.data;
    const id = modelControl.data;

    const currentUser = useCurrentUser();
    const [data, setField, setData] = useFormData<TestingDataFilterData>({ filters: [] } as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const [testingResultDropdownOptions, setTestingResultDropdownOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
        setLoading(true);
        restRequest<DropdownOption[]>('svn_repository/result_dropdown_options').then(setTestingResultDropdownOptions).finally(() => setLoading(false))
    }, []);

    useEffect(() => {
        setData({ filters: [], description: '' } as any);
        setInvalidError({});
        if (id) {
            setLoading(true);
            restRequest<TestingDataFilterData>('testing_settings/filters/' + id).then(d => {
                setData(d);
            }).finally(() => setLoading(false))
        }
    }, [id, refresh]);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.preventDefault();

        setLoading(true);

        restRequest<TestingDataFilterData>(`testing_settings/filters/${isCreate ? '' : id}`, data, isCreate ? 'post' : 'put').then(result => {
            onFinish(result);
            setData({} as any);
            setInvalidError({});
            setRefresh(v => v + 1);
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }


    return <>
        <Modal {...modelControl.props} size="fullscreen">
            <Modal.Header>{isCreate ? 'Create' : 'Update'} Custom Filters </Modal.Header>
            <Modal.Content>
                <Form onSubmit={onSubmit} loading={loading || loading2}>

                    <Form.Group widths="equal">
                        <Form.Input label="Name" name="name" value={data.name || ''} onChange={setField} error={fieldError('name', invalidError)}></Form.Input>

                        <Form.Input label="Testing Station" error={fieldError('testing_result_id', invalidError)}>
                            <TestingDataDropdown name="testing_result_id" value={data.testing_result_id} options={testingResultDropdownOptions} onChange={setField} />
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="Filters" fluid>
                            <FiltersEditor value={data.filters} invalidError={invalidError} onChange={setField}
                                current_testing_result_id={data.testing_result_id} parentPath="filters" testingResultDropdownOptions={testingResultDropdownOptions} />
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="Description" error={fieldError('description', invalidError)}>
                            <TextArea
                                name="description"
                                value={data.description}
                                onChange={setField}></TextArea>
                        </Form.Input>
                    </Form.Group>
                    {(currentUser.permissions.testing.setting.filter.create || currentUser.permissions.testing.setting.filter.update) && <div>
                        <Button primary>Submit</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button as="a" onClick={e => props.modalControl.setOpen(false)}>Cancel</Button>
                    </div>}
                </Form>
            </Modal.Content>
        </Modal>
    </>
}

function FiltersEditor(props: { value: TestingDataFilter[], invalidError: any, onChange: (e: any, d: any) => void, current_testing_result_id: number, parentPath: string, testingResultDropdownOptions: DropdownOption[] }) {
    const { value, invalidError, onChange, current_testing_result_id, parentPath, testingResultDropdownOptions } = props;

    return <Table striped selectable compact size="small">
        <Table.Header>
            <tr>
                <th style={{ width: '5rem' }}>Logic</th>
                <th>Testing Testing</th>
                <th>Field</th>
                <th>Operator</th>
                <th>Value</th>
                <th>
                    <Button.Group color='blue' size="mini">
                        <Button icon="add" onClick={e => {
                            e.preventDefault();
                            onChange(null, { name: `${parentPath}`, value: [...value, { logic: 'and', testing_result_id: 0, field: '' }] })
                        }}></Button>
                        <Dropdown
                            className='button icon'
                            floating
                        >
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={e => {
                                    e.preventDefault();
                                    onChange(null, { name: `${parentPath}`, value: [...value, { logic: 'and', field: 'children', testing_result_id: 0, children: [] }] })
                                }}>Indent</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Button.Group>
                </th>
            </tr>
        </Table.Header>
        <Table.Body>
            {value.map((filter, filterIndex) => <OneFilterEditer key={filterIndex + 'd'} value={filter} invalidError={invalidError}
                valueIndex={filterIndex} parentPath={`${parentPath}[${filterIndex}]`}
                onChange={onChange} onDelete={() => onChange(null, { name: parentPath, value: value.filter((f, i) => i !== filterIndex) })}
                current_testing_result_id={current_testing_result_id}
                testingResultDropdownOptions={testingResultDropdownOptions} />)}
        </Table.Body>
    </Table>
}


function OneFilterEditer(props: { value: TestingDataFilter, valueIndex: number, invalidError: any, onChange: (e: any, d: any) => void, current_testing_result_id: number, parentPath: string, testingResultDropdownOptions: DropdownOption[], onDelete: () => void }) {
    const { value, valueIndex, invalidError, onChange, current_testing_result_id, parentPath, testingResultDropdownOptions, onDelete } = props;
    const result_id = value.testing_result_id || current_testing_result_id
    const [fieldConfigs, setFieldConfigs] = useState<FieldConfigs>({ fields: [], types: {}, result_id });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (result_id) {
            setLoading(true);
            restRequest<TestingResultOptionsData>(`testing_settings/testing_result_options/${result_id}`, null, 'get', undefined, result_id + '').then(d => {
                d.measurements = d.measurements?.sort((m1, m2) => compareMeasurementName(m1.name, m2.name))
                const fcs = generateFilterFieldsConfig(d, result_id);
                setFieldConfigs(fcs);
            }).finally(() => setLoading(false));
        }
    }, [result_id]);

    return <tr>
        <td style={{ width: '5rem' }}>
            {valueIndex !== 0 && <Select compact name={`${parentPath}.logic`} value={value.logic} options={['and', 'or'].map(o => ({ key: o, value: o, text: o }))} onChange={onChange} error={fieldError(`${parentPath}.logic`, invalidError)}></Select>}
        </td>
        {value.field === 'children' ? <>
            <td colSpan={4}>
                <FiltersEditor value={value.children || []} invalidError={invalidError} parentPath={`${parentPath}.children`} onChange={onChange}
                    current_testing_result_id={current_testing_result_id} testingResultDropdownOptions={testingResultDropdownOptions} />
            </td>
        </>
            :
            <>
                <td>
                    <Form.Input error={fieldError(`${parentPath}.testing_result_id`, invalidError)} loading={loading}>
                        <TestingDataDropdown name={`${parentPath}.testing_result_id`} value={value.testing_result_id} options={testingResultDropdownOptions} onChange={onChange} placeholder="Default" />
                    </Form.Input>
                </td>
                <td>
                    <Form.Input error={fieldError(`${parentPath}.field`, invalidError)}>
                        <Select search value={value.field} onChange={(e, d) => {
                            const newValue = d.value as string;
                            const initOperator = !value.field || !newValue || !_.isEqual(fieldConfigs.types[value.field], fieldConfigs.types[newValue])
                            onChange(null, { name: `${parentPath}`, value: { ...value, field: newValue, operator: initOperator ? '' : value.operator, value: initOperator ? '' : value.value, children: initOperator ? [] : value.children } })
                        }}
                            options={fieldConfigs.fields.filter(f => f !== 'children').map(f => {
                                const fs = f.split('#')
                                if (fs.length === 2) {
                                    return { key: fs[0], value: fs[0], text: fs[1] };
                                } else {
                                    return { key: f, value: f, text: f.split('_').map(v => _.capitalize(v)).join(' ') };
                                }
                            })} loading={loading}></Select>
                    </Form.Input>
                </td>
                <td>
                    <Form.Input error={fieldError(`${parentPath}.operator`, invalidError)}>
                        <FilterOperator fieldConfigs={fieldConfigs} fieldName={value.field} value={value.operator || ''} onChange={operator => {
                            onChange(null, { name: `${parentPath}.operator`, value: operator })
                        }}></FilterOperator>
                    </Form.Input>
                </td>
                <td>
                    <Form.Input error={fieldError(`${parentPath}.value`, invalidError)}>
                        <FilterValue fieldConfigs={fieldConfigs} fieldName={value.field} value={value.value} onChange={filterValue => {
                            onChange(null, { name: `${parentPath}.value`, value: filterValue })
                        }}></FilterValue>
                    </Form.Input>
                </td>
            </>}
        <td>
            <Button size="mini" icon="remove" color="red" onClick={e => {
                e.preventDefault();
                const $tr = $(e.target).closest('tr');
                $tr.fadeOut(() => {
                    onDelete();
                    nextTick(() => $tr.show());
                });
            }}></Button>
        </td>
    </tr>
}

function FilterOperator(props: { fieldConfigs: FieldConfigs, fieldName: string, value: string, onChange: (value: string) => void }) {
    const { fieldConfigs, fieldName, value, onChange } = props;
    if (!fieldName) {
        return <></>;
    }

    if (!fieldConfigs.types[fieldName]) {
        // string
        return <Select value={value} onChange={(e, d) => onChange(d.value as string)} options={[{ key: '=', value: '=', text: '=' }, { key: '!=', value: '!=', text: '!=' }, { key: 'contains', value: 'contains', text: 'Contains' }, { key: 'not_contains', value: 'not_contains', text: 'Not Contains' }]}></Select>
    } else {
        const [type, config] = fieldConfigs.types[fieldName];

        if (['pass_on', 'fail_on', 'invalid_on', 'unknown_on'].includes(fieldName)) {
            return <Select value={value} onChange={(e, d) => onChange(d.value as string)} options={[{ key: '=', value: '=', text: '=' }, { key: 'only', value: 'only', text: 'only' }]}></Select>
        } else if (type === 'datetime') {
            // date
            return <Select value={value} onChange={(e, d) => onChange(d.value as string)} options={[{ key: '=', value: '=', text: '=' }, { key: '>', value: '>', text: '>' }, { key: '>=', value: '>=', text: '>=' }, { key: '<', value: '<', text: '<' }, { key: '<=', value: '<=', text: '<=' }]}></Select>
        } else if (type === 'enum') {
            // enum
            return <Select value={value} onChange={(e, d) => onChange(d.value as string)} options={[{ key: '=', value: '=', text: '=' }, { key: '!=', value: '!=', text: '!=' }]}></Select>
        } else if (type === 'limit') {
            // limit
            return <Select value={value} onChange={(e, d) => onChange(d.value as string)} options={[{ key: 'pass', value: 'pass', text: 'pass' }, { key: 'fail', value: 'fail', text: 'fail' }]}></Select>
        }
    }

    return <></>
}

function FilterValue(props: { fieldConfigs: FieldConfigs, fieldName: string, value: any, onChange: (value: any) => void }) {
    const { fieldConfigs, fieldName, value, onChange } = props;

    if (!fieldName || _.isEmpty(fieldConfigs.types)) {
        return <></>;
    }

    if (!fieldConfigs.types[fieldName]) {
        // string

        return <StringValue {...props}></StringValue>
    } else {
        const [type, config] = fieldConfigs.types[fieldName];
        if (type === 'datetime') {
            // date
            return <ReactDatePicker showTimeSelect
                dateFormat="yyyy-MM-d HH:mm"
                timeFormat="HH:mm"
                selected={value && moment(value, 'YYYY-MM-DD HH:mm:ss').toDate()} onChange={(ds: Date) => onChange([moment(ds).format('YYYY-MM-DD HH:mm:ss')])}></ReactDatePicker>
        } else if (type === 'enum') {
            // enum
            return <Dropdown selection search multiple inline value={value || ''} onChange={(e, d) => onChange(d.value)} options={(config as string[][]).map(c => ({ key: c[0], value: c[0], text: c[1] }))}></Dropdown>
        } else if (type === 'limit') {
            return <LimitValue {...props}></LimitValue>
        }
    }


    return <></>
}

function StringValue(props: { fieldConfigs: FieldConfigs, fieldName: string, value: any, onChange: (value: any) => void }) {
    const { value, onChange } = props;
    const editStringControl = useModalControl<string>('');

    const [stringValue, setStringValue] = useState('');
    const [stringSettings, setStringSettings] = useState<{ trimStart?: boolean, trimEnd?: boolean, removeEmpty?: boolean, removeRepeated?: boolean }>({ trimStart: true, trimEnd: true, removeEmpty: true });

    useEffect(() => {
        setStringValue((_.isArray(value) ? value : [value]).filter(v => !_.isNil(v) && !_.isNaN(v)).join("\n"))
    }, [value])


    const valueArray = (_.isArray(value) ? value : [value]).filter(v => !_.isNil(v) && !_.isNaN(v));

    return <div>
        {valueArray.map((v, i) => {
            return <Label as="a" title="Click to Edit" key={'l' + i}>{v} <Icon onClick={(e: any) => {
                e.preventDefault();
                onChange([...valueArray.slice(0, i), ...valueArray.slice(i + 1)]);
            }} name='delete' color="red" /></Label>
        })}

        <Button onClick={e => {
            e.preventDefault();
            editStringControl.setOpen(true);
        }} icon="edit" as="a" size="mini" color="blue"></Button>

        <Modal {...editStringControl.props} size="large">
            <Modal.Header>
                Edit text values, one line one value
            </Modal.Header>
            <Modal.Content>
                <form onSubmit={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    let values = stringValue.split(/\r?\n/);
                    if (stringSettings['trimStart']) {
                        values = values.map(v => v.trimStart());
                    }
                    if (stringSettings['trimEnd']) {
                        values = values.map(v => v.trimEnd());
                    }
                    if (stringSettings['removeEmpty']) {
                        values = values.filter(v => !!v);
                    }
                    if (stringSettings['removeRepeated']) {
                        values = _.uniq(values)
                    }
                    onChange(values);
                    editStringControl.setOpen(false);
                }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto auto', padding: '0 0 1rem 0' }}>
                        <Checkbox checked={stringSettings.trimStart} onClick={(e, d) => setStringSettings(s => ({ ...s, trimStart: d.checked }))} label="Trim Start" fitted></Checkbox>
                        <Checkbox checked={stringSettings.trimEnd} onClick={(e, d) => setStringSettings(s => ({ ...s, trimEnd: d.checked }))} label="Trim End" fitted></Checkbox>
                        <Checkbox checked={stringSettings.removeEmpty} onClick={(e, d) => setStringSettings(s => ({ ...s, removeEmpty: d.checked }))} label="Remove Empty" fitted></Checkbox>
                        <Checkbox checked={stringSettings.removeRepeated} onClick={(e, d) => setStringSettings(s => ({ ...s, removeRepeated: d.checked }))} label="Remove Repeated" fitted></Checkbox>
                    </div>
                    <TextArea name="values" value={stringValue} onChange={(e, d) => {
                        setStringValue(d.value as string);
                    }} style={{ width: '100%', height: '600px' }}></TextArea>

                    <br />

                    <Button type="submit" color="blue">Set</Button>
                    <Button as="a" onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();

                        editStringControl.setOpen(false);
                    }}>Cancel</Button>
                </form>
            </Modal.Content>
        </Modal>
    </div>
}

function LimitValue(props: { fieldConfigs: FieldConfigs, fieldName: string, value: any, onChange: (value: any) => void }) {
    const { fieldConfigs, fieldName, value, onChange } = props;
    const editStringControl = useModalControl<string>('');

    const [data, setField, setData] = useFormData<{ measurement_key: string, channel: number, limits: any }>(value || {});
    const [invalidError, setInvalidError] = useState<any>({});

    const [limitValue, setLimitValue] = useState('');
    const [limitStr, setLimitStr] = useState('');
    const updateLimitValueRef = useRef<(textValue: string) => boolean>();

    const [type, config] = fieldConfigs.types[fieldName];
    const availableMeasurements = config as TestingResultOptionsData['measurements'];
    const measurement = data.measurement_key ? availableMeasurements.find(m => m.key === data.measurement_key) : undefined;
    const oldMeasurement = data.measurement_key ? availableMeasurements.find(m => m.key === value?.measurement_key) : undefined;

    const previousDataTypeRef = useRef(measurement?.data_type || -1);

    useEffect(() => {
        setData(value || {});

        if (value?.data_type === DATA_TYPE_OTHER) {
            setLimitStr(value?.limits || '')
        }
        else if (value?.data_type === DATA_TYPE_SCALAR) {
            setLimitStr(`Lower: ${value?.limits?.[0] || 0}, Upper: ${value?.limits?.[1] || 0}`);
        }
        else if (value?.data_type === DATA_TYPE_ARRAY) {
            const lowers = value?.limits?.[0] || [0]
            const uppers = value?.limits?.[1] || [0]
            setLimitStr(`Lower: [${lowers.join(',')}], Upper: [${uppers.join(',')}]`)
        } else if (measurement?.data_type === DATA_TYPE_VECTOR) {
            const xValues = value?.limits?.[0] || [0]
            const lowers = value?.limits?.[1] || [0]
            const uppers = value?.limits?.[2] || [0]

            setLimitStr(`X: [${xValues.join(',')}], Lower: [${lowers.join(',')}], Upper: [${uppers.join(',')}]`)
        }
    }, [value]);


    useEffect(() => {
        let limits = data.limits;

        // on data type change
        if (measurement?.data_type !== previousDataTypeRef.current) {
            setData(ds => ({ ...ds, limits: undefined }));
            limits = undefined;
            setInvalidError((vs: any) => ({ ...vs, limits: undefined }));

            previousDataTypeRef.current = measurement?.data_type || -1;
        }

        if (measurement?.data_type === DATA_TYPE_OTHER) {
            setLimitValue(limits || '')

            updateLimitValueRef.current = function (textValue: string) {
                setData(ds => ({ ...ds, limits: textValue, data_type: DATA_TYPE_OTHER }));
                setInvalidError((vs: any) => ({ ...vs, limits: undefined }));

                return true;
            }
        } else if (measurement?.data_type === DATA_TYPE_SCALAR) {
            setLimitValue(`Lower Upper\n ${limits?.[0] || 0}  ${limits?.[1] || 0}`)

            updateLimitValueRef.current = function (textValue: string) {
                const rows = textValue.split(/\r?\n/)
                if (rows.length < 2) {
                    setInvalidError((vs: any) => ({ ...vs, limits: "Invalid Format for Scalar Limits" }));
                    return false;
                }

                const values = rows[1].trim().split(/\s+/)
                if (values.length < 2) {
                    setInvalidError((vs: any) => ({ ...vs, limits: "Invalid Format for Scalar Limits in 2st Row" }));
                    return false;
                }
                const lower = parseFloat(values[0])
                const upper = parseFloat(values[1])
                if (isNaN(lower) || isNaN(upper)) {
                    setInvalidError((vs: any) => ({ ...vs, limits: "Invalid Format for Scalar Limits in 2st Row" }));
                    return false;
                }

                setData(ds => ({ ...ds, limits: [lower, upper], data_type: DATA_TYPE_SCALAR }));
                setInvalidError((vs: any) => ({ ...vs, limits: undefined }));
                return true;
            }
        } else if (measurement?.data_type === DATA_TYPE_ARRAY) {
            const indexes = limits?.[0] || [0]
            const lowers = limits?.[1] || [0]
            const uppers = limits?.[2] || [0]

            let tmpLimitValue = `Index Lower Upper`
            indexes.forEach(function (v: number, i: number) {
                tmpLimitValue += '\n'
                tmpLimitValue += `${v} ${lowers[i]}  ${uppers[i]}`
            });
            setLimitValue(tmpLimitValue);

            updateLimitValueRef.current = function (textValue: string) {
                const rows = textValue.split(/\r?\n/)
                if (rows.length < 2) {
                    setInvalidError((vs: any) => ({ ...vs, limits: "Invalid Format for Array Limits" }));
                    return false;
                }

                let hasError = false;
                const indexValues: number[] = []
                const lowers: number[] = []
                const uppers: number[] = []
                rows.slice(1).forEach((row, i) => {
                    const values = row.trim().split(/\s+/)
                    if (values.length < 2) {
                        setInvalidError((vs: any) => ({ ...vs, limits: `Invalid Format for Array Limits in ${i + 2}st Row` }));
                        hasError = true;
                        return;
                    }

                    const index = parseInt(values[0])
                    const lower = parseFloat(values[1])
                    const upper = parseFloat(values[2])
                    if (isNaN(index) || isNaN(lower) || isNaN(upper)) {
                        setInvalidError((vs: any) => ({ ...vs, limits: `Invalid Format for Array Limits in ${i + 2}st Row` }));
                        hasError = true;
                        return;
                    }

                    indexValues.push(index)
                    lowers.push(lower)
                    uppers.push(upper)
                })

                if (!hasError) {
                    setData(ds => ({ ...ds, limits: [indexValues, lowers, uppers], data_type: DATA_TYPE_ARRAY }));
                    setInvalidError((vs: any) => ({ ...vs, limits: undefined }));
                }

                return !hasError;
            }
        } else if (measurement?.data_type === DATA_TYPE_VECTOR) {
            const xValues = limits?.[0] || [0]
            const lowers = limits?.[1] || [0]
            const uppers = limits?.[2] || [0]

            let tmpLimitValue = `X Lower Upper`
            xValues.forEach(function (v: number, i: number) {
                tmpLimitValue += '\n'
                tmpLimitValue += `${v} ${lowers[i]}  ${uppers[i]}`
            });
            setLimitValue(tmpLimitValue);

            updateLimitValueRef.current = function (textValue: string) {
                const rows = textValue.split(/\r?\n/)
                if (rows.length < 2) {
                    setInvalidError((vs: any) => ({ ...vs, limits: "Invalid Format for Vector Limits" }));
                    return false;
                }

                let hasError = false;
                const xValues: number[] = []
                const lowers: number[] = []
                const uppers: number[] = []
                rows.slice(1).forEach((row, i) => {
                    const values = row.trim().split(/\s+/)
                    if (values.length < 2) {
                        setInvalidError((vs: any) => ({ ...vs, limits: `Invalid Format for Vector Limits in ${i + 2}st Row` }));
                        hasError = true;
                        return;
                    }

                    const x = parseFloat(values[0])
                    const lower = parseFloat(values[1])
                    const upper = parseFloat(values[2])
                    if (isNaN(x) || isNaN(lower) || isNaN(upper)) {
                        setInvalidError((vs: any) => ({ ...vs, limits: `Invalid Format for Vector Limits in ${i + 2}st Row` }));
                        hasError = true;
                        return;
                    }

                    xValues.push(x)
                    lowers.push(lower)
                    uppers.push(upper)
                })

                if (!hasError) {
                    setData(ds => ({ ...ds, limits: [xValues, lowers, uppers], data_type: DATA_TYPE_VECTOR }));
                    setInvalidError((vs: any) => ({ ...vs, limits: undefined }));
                }

                return !hasError;
            }
        } else {
            updateLimitValueRef.current = () => false;
        }
    }, [data.limits, measurement?.data_type])

    return <div>
        Measurement: {oldMeasurement?.name}
        <br />
        Channel: {value?.channel}
        <br />
        Limit: {limitStr}

        <Button onClick={e => {
            e.preventDefault();
            previousDataTypeRef.current = value?.data_type;
            setData(value);
            editStringControl.setOpen(true);
        }} icon="edit" as="a" size="mini" color="blue"></Button>

        <Modal {...editStringControl.props} size="large">
            <Modal.Header>
                Edit {['', 'Scalar', 'Array', 'Vector', 'Regex'][measurement?.data_type || 0]} Limits
            </Modal.Header>
            <Modal.Content>
                <Form onSubmit={e => {
                    e.preventDefault();
                    e.stopPropagation();

                    let invalid = false;
                    if (!data.measurement_key) {
                        invalid = true;
                        setInvalidError((iv: any) => ({...iv, measurement_key: "It's required"}));
                    } else {
                        setInvalidError((iv: any) => ({...iv, measurement_key: undefined}));
                    }

                    if (!data.channel) {
                        invalid = true;
                        setInvalidError((iv: any) => ({...iv, channel: "It's required"}));
                    } else {
                        setInvalidError((iv: any) => ({...iv, channel: undefined}));
                    }

                    if (invalid || !_.isEmpty(_.values(invalidError).filter(v => v))) {
                        notificationControl.showError('Please fixed the invalid errors first');
                        return;
                    }

                    onChange(data);
                    editStringControl.setOpen(false);
                }}>
                    <Form.Group widths="equal">
                        <Form.Input label="Measurement" required error={fieldError('measurement_key', invalidError)}>
                            <Dropdown selection search
                                value={data.measurement_key}
                                name="measurement_key"
                                onChange={setField}
                                options={availableMeasurements.map(m => ({ key: m.key, value: m.key, text: m.name }))}></Dropdown>
                        </Form.Input>

                        <Form.Input label="Channel" required error={fieldError('channel', invalidError)}>
                            <Dropdown selection search
                                value={data.channel}
                                name="channel"
                                onChange={setField}
                                options={[{ key: 1, value: 1, text: 'Channel1' }, { key: 2, value: 2, text: 'Channel2' }]}></Dropdown>
                        </Form.Input>
                    </Form.Group>

                    <Form.Group widths="equal">
                        <Form.Input label="Limits" required error={fieldError('limits', invalidError)}>
                            <TextArea value={limitValue} onChange={(e, d) => setLimitValue(d.value as string)} onBlur={(e: any) => {
                                updateLimitValueRef.current && updateLimitValueRef.current(e.currentTarget.value as string)
                            }}
                                style={{ height: '600px' }}>
                            </TextArea>
                        </Form.Input>
                    </Form.Group>

                    <Button type="submit" color="blue">Set</Button>
                    <Button as="a" onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();

                        editStringControl.setOpen(false);
                    }}>Cancel</Button>
                </Form>
            </Modal.Content>
        </Modal>
    </div>
}